var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebCamOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.14966 6.15138C5.26351 7.49721 4.86881 9.10754 5.03217 10.7106C5.19553 12.3137 5.90695 13.8113 7.04636 14.9507C8.18576 16.0901 9.68338 16.8015 11.2864 16.9649C12.8895 17.1282 14.4998 16.7335 15.8457 15.8474M17.8457 13.8474C18.7325 12.5013 19.1277 10.8904 18.9643 9.28675C18.801 7.68308 18.0891 6.18493 16.9491 5.04534C15.809 3.90574 14.3106 3.19454 12.7068 3.03185C11.1031 2.86916 9.49236 3.26495 8.14666 4.15238",
    stroke: "#656667",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12982 9.12187C8.97026 9.64233 8.95531 10.1964 9.08658 10.7247C9.21786 11.253 9.49041 11.7356 9.87503 12.1209C10.2596 12.5061 10.7418 12.7794 11.2699 12.9115C11.798 13.0437 12.3521 13.0296 12.8728 12.8709M14.8728 10.8709C15.0287 10.3518 15.0411 9.80025 14.9087 9.27473C14.7763 8.74921 14.504 8.26937 14.1207 7.88621C13.7374 7.50304 13.2575 7.23086 12.732 7.09856C12.2064 6.96627 11.6548 6.97882 11.1358 7.13487",
    stroke: "#656667",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00079 16L5.90979 19.486C5.81889 19.6377 5.76984 19.8108 5.76765 19.9876C5.76547 20.1645 5.81021 20.3387 5.89733 20.4926C5.98444 20.6465 6.11081 20.7746 6.26355 20.8637C6.41629 20.9528 6.58994 20.9999 6.76679 21H17.2348C17.4116 20.9999 17.5853 20.9528 17.738 20.8637C17.8908 20.7746 18.0171 20.6465 18.1042 20.4926C18.1914 20.3387 18.2361 20.1645 18.2339 19.9876C18.2317 19.8108 18.1827 19.6377 18.0918 19.486L16.0008 16",
    stroke: "#656667",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3L21 21",
    stroke: "#656667",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebCamOff);
export default __webpack_public_path__ + "static/media/WebCamOff.ae79b79162b74cf468150b087c3dfac1.svg";
export { ForwardRef as ReactComponent };